export default "__VITE_ASSET__BuDUAlvM__"